import React, { useState } from "react";
import { Link } from "react-router-dom";
import './header.css';

const Header: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className="header">
      <div className="header-logo">
        <a href="/"><img src="/header-logo.png" alt="GM" /></a>
      </div>

      <nav className={`nav ${isMobileMenuOpen ? 'mobile-menu-open' : ''}`}>
        <ul className="nav-list">
          <li>
            <Link to={"/"} onClick={() => setIsMobileMenuOpen(false)}>Home</Link>
          </li>
          <li>
            <Link to={"/petroleum-portfolio"} onClick={() => setIsMobileMenuOpen(false)}>Gas Station & Convenience Store Portfolio</Link>
          </li>
          <li>
            <Link to={"/hospitality-services"} onClick={() => setIsMobileMenuOpen(false)}>Hospitality Portfolio</Link>
          </li>
          <li>
            <Link to={"/real-estate-development"} onClick={() => setIsMobileMenuOpen(false)}>Real Estate & Development</Link>
          </li>
          <li>
            <Link to={"/contact-us"} onClick={() => setIsMobileMenuOpen(false)}>Contact Us</Link>
          </li>
        </ul>
      </nav>

      <button className="mobile-menu-button" onClick={toggleMobileMenu}>
        <div className={`bar ${isMobileMenuOpen ? 'open' : ''}`}></div>
        <div className={`bar ${isMobileMenuOpen ? 'open' : ''}`}></div>
        <div className={`bar ${isMobileMenuOpen ? 'open' : ''}`}></div>
      </button>
    </header>
  );
};

export default Header;